const MANAGE_USER_LOADING = "MANAGE_USER_LOADING";
const MANAGE_USER_SUCCESS = "MANAGE_USER_SUCCESS";
const MANAGE_USER_ERROR = "MANAGE_USER_ERROR";
export { MANAGE_USER_LOADING, MANAGE_USER_SUCCESS, MANAGE_USER_ERROR };
